export const SOURCE = 'SOURCE';

export const SINK = 'SINK';
export const DATASET = 'DATASET';
export const ALERT = 'ALERT';
export const UNREAD = 'UNREAD';
export const ALL = 'ALL';
export const MAIN_ALL = 'MAIN_ALL';
export const USER = 'USER';
